/**
 * 语言切换器组件
 */

import React from 'react';
import { Button, Dropdown, Space, MenuProps } from 'antd';
import { GlobalOutlined, CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { supportedLanguages, changeLanguage } from '@/locales';

interface LanguageSwitcherProps {
  /** 按钮大小 */
  size?: 'small' | 'middle' | 'large';
  /** 显示类型：button-完整按钮, icon-仅图标 */
  type?: 'button' | 'icon';
  /** 是否显示语言标签 */
  showLabel?: boolean;
  /** 按钮样式 */
  buttonStyle?: React.CSSProperties;
}

/**
 * 语言切换器组件
 * 支持简体中文、英文、繁体中文三种语言切换
 */
const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  size = 'middle',
  type = 'button',
  showLabel = true,
  buttonStyle,
}) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // 获取当前语言信息
  const currentLang = supportedLanguages.find(lang => lang.key === currentLanguage) || supportedLanguages[0];

  // 处理语言切换
  const handleLanguageChange = (langKey: string) => {
    changeLanguage(langKey);
  };

  // 语言选项
  const languageItems: MenuProps['items'] = supportedLanguages.map(lang => ({
    key: lang.key,
    label: (
      <Space style={{ minWidth: 100 }}>
        <span>{lang.flag}</span>
        <span>{lang.label}</span>
        {lang.key === currentLanguage && (
          <CheckOutlined style={{ marginLeft: 'auto', color: '#1890ff' }} />
        )}
      </Space>
    ),
    onClick: () => handleLanguageChange(lang.key),
  }));

  // 渲染语言切换按钮
  const renderLanguageButton = () => {
    if (type === 'icon') {
      return (
        <Button
          type="text"
          size={size}
          icon={<GlobalOutlined />}
          style={buttonStyle}
        >
          {showLabel && currentLang?.flag}
        </Button>
      );
    }

    return (
      <Button
        size={size}
        icon={<GlobalOutlined />}
        style={buttonStyle}
      >
        <Space>
          {currentLang?.flag}
          {showLabel && currentLang?.label}
        </Space>
      </Button>
    );
  };

  return (
    <Dropdown
      menu={{
        items: languageItems,
        selectedKeys: [currentLanguage],
      }}
      placement="bottomRight"
      arrow
    >
      {renderLanguageButton()}
    </Dropdown>
  );
};

export default LanguageSwitcher;